export enum BookFont {
  DEFAULT = "default",
  SANS = "--RS__sansTf",
  OLD_STYLE = "--RS__oldStyleTf",
  MODERN = "--RS__modernTf",
  HUMANIST = "--RS__humanistTf",
  MONO = "--RS__monospaceTf",
  DYSLEXIC = "--RS__openDyslexicTf",
  HYPERLEGIBLE = "--RS__hyperlegibleTf",
}

export enum DisplayMode {
  NONE = "",
  DAY = "day",
  NIGHT = "night",
  SEPIA = "sepia",
  CYAN = "cyan",
}

export const NO_MARGIN = "inherit";
export const NO_LINE_HEIGHT = "";
export const NO_FONT_SIZE = 1;

export enum FontSize {
  SMALL = 1,
  MEDIUM = 1.5,
  LARGE = 2,
  EXTRA_LARGE = 4,
}

export enum LineHeight {
  SMALL = 1,
  MEDIUM = 1.5,
  LARGE = 2,
}

export enum PageMargin {
  SMALL = 1,
  MEDIUM = 2.5,
  LARGE = 5,
}

export const CC_DEFAULT_CONFIG_0 = "cc_default_config_0";
export function getDefaultSettingConfig() {
  return {
    fontFamily: BookFont.HUMANIST,
    displayMode: DisplayMode.DAY,
    pageMargin: PageMargin.SMALL,
    fontSize: FontSize.MEDIUM,
    lineHeight: LineHeight.MEDIUM,
  };
}
